import { useState } from 'preact/hooks';
import type { ExtensionView } from '../../core/x509/parse';
import { hex } from '../format';
import { Badge } from './Badge';
import { HexView } from './HexView';

export function ExtensionList({ extensions }: { extensions: ExtensionView[] }) {
  if (extensions.length === 0) return <p class="muted">No extensions.</p>;
  return (
    <ul class="ext-list">
      {extensions.map((e) => <ExtensionItem key={e.oid + hex(e.value).slice(0, 16)} ext={e} />)}
    </ul>
  );
}

function ExtensionItem({ ext }: { ext: ExtensionView }) {
  const [raw, setRaw] = useState(false);
  return (
    <li class="ext">
      <div class="ext-head">
        <b>{ext.name}</b>
        <code class="muted tiny">{ext.oid}</code>
        {ext.critical && <Badge tone="warn">critical</Badge>}
        <span class="muted tiny">{ext.value.length} B</span>
        <button type="button" class="btn btn-sm btn-ghost right" onClick={() => setRaw((v) => !v)}>{raw ? 'Decoded' : 'Bytes'}</button>
      </div>
      {ext.text && !raw && <pre class="ext-text">{ext.text.replace(/^[^\n]*:\n/, '')}</pre>}
      {!ext.text && !raw && <div class="mono tiny wrap muted" style="margin-top:0.3rem">{hex(ext.value).slice(0, 120)}{ext.value.length > 60 ? '…' : ''}</div>}
      {raw && <HexView data={ext.value} />}
    </li>
  );
}
